module.exports = __webpack_public_path__ + "img/performance-work-icon1.7ce4f69a.png";